//helpers
import { flagBuilder, getFlagStyle } from '@/helpers/Paths';

//interfaces
import {ILanguagesTab} from '@/interfaces/languages';
import { INotificationBar } from '../../NotificationBar';

//components
import { BasicButton, LoadingSpinner } from 'thrive-components';
import ModalWrapper from '@/components/modals/ModalWrapper';
import LanguageSettings from '@/components/modals/LanguageSettings';

//hooks
import { UseLanguagesTab } from '../languagesTab/LanguagesTab.hooks';



const LanguagesTab = ({show, setDctEnabled, dctEnabled, setQuickTranslateDisabled, toggleNotification}:ILanguagesTab) => {
    const {
        languages,
        handleChecked,
        formTouched,
        submit,
        loading,
        downloadReport,
        settingsLanguage,
        settingsModal,
        settingsSelected,
        setSettingsModal,
    } = UseLanguagesTab({show, setDctEnabled, dctEnabled, setQuickTranslateDisabled, toggleNotification});

    if (!show) { return <></> }
    return (
        <>
        <div className="languages-tab">            
            <p className='language-explainer'>Select the languages your app should support (English is selected by default):</p>

            <div className="lang-list">

                <ul> 
                    {languages.map(item => {
                        return (
                            <li key={item.languageId}>
                                <div className='check-container'>
                                    <input value={item.languageId} checked={item.enabled ? true : false} type="checkbox"  onChange={() => handleChecked(item)} /> 
                                </div>  

                                <div className='divider'></div>

                                <div className='flag' style={getFlagStyle(flagBuilder(item.flagRegionCode))}>&nbsp;</div>

                                <span>{item.name}</span>

                                <div className='button-container'>
                                    {dctEnabled && <button disabled={!item.enabled || !item.settingsSaved ? true : false} onClick={() => {settingsSelected(item)}} className={!item.enabled || !item.settingsSaved ? 'disabled' : ''}>Settings</button> }
                                </div>
                            </li>
                        )
                    })}             
                </ul>
            </div>

            <div className='controls-container'>
                <BasicButton 
                    className={`${!formTouched ? 'disabled' : ''} save-button`}
                    ariaLabel={'Save Changes'}
                    isDisabled={!formTouched}
                    onButtonClick={submit}
                    content={<>
                        Save
                        {loading && <LoadingSpinner size={5} />}
                    </>} 
                />

                {dctEnabled && 
                    <BasicButton 
                        className={`download`}
                        ariaLabel={'Download Report'}
                        onButtonClick={downloadReport}
                        content={"Download Report"} 
                    />
                }
            </div>
        </div>

        {settingsLanguage &&
            <ModalWrapper className="languageSettingsContainer" isOpen={settingsModal} onRequestClose={() => setSettingsModal(false)}>
                <LanguageSettings 
                    close={(notif:INotificationBar) => { 
                        setSettingsModal(false); 
                        toggleNotification(notif); 
                    }} 
                    language={settingsLanguage} 
                />
            </ModalWrapper> 
        }
        </>
    );
};

export default LanguagesTab;